import React, { useState } from 'react';
import Switch from '@mui/material/Switch';

/**
 * Componente de switch personalizado.
 * @param {number|bool} status - Status do toggle.
 * @param {string} top - Distância top do elemento.
 * @param {function} onChange - Função de retorno de chamada para o evento de clique.
 */
export default function SwitchComponente(props) {
  const [checked, setChecked] = useState(props.status ? true : false);

  const handleChange = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    props.onChange && props.onChange(newChecked);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        marginTop: props.top || 0,
      }}
    >
      <Switch
        color="success"
        checked={props.status}
        onChange={handleChange}
        disabled={props.disabled}
      />
    </div>
  );
}
